import React from 'react';

export const Footer: React.FC = () => (
  <footer className="border-t border-white/10 bg-solana-900/50 py-6 text-center text-xs text-white/60">
    <p>© {new Date().getFullYear()} Solante Labs. All original assets. House treasury fee: 3%.</p>
    <p className="mt-2">
      Game fairness verified via commit–reveal shuffles &amp; Solana smart contracts.
    </p>
  </footer>
);
